const WhyCardContent = [
  {
    title: "Complement communication software",
    content:
      "Integration with your communication platform.",
  },
  {
    title: "Increase participant interaction",
    content:
      "We offer in-game voice chat, text chat, interactive objects and real-time multiplayer",
  },
  {
    title: "Easy to deploy",
    content:
      "Fully customizable maps and light weight backend for deployment on servers",
  },
];

export default WhyCardContent;
